import { render, staticRenderFns } from "./mProductCard3.vue?vue&type=template&id=eeddb0e6&scoped=true"
import script from "./mProductCard3.vue?vue&type=script&lang=js"
export * from "./mProductCard3.vue?vue&type=script&lang=js"
import style0 from "./mProductCard3.vue?vue&type=style&index=0&id=eeddb0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeddb0e6",
  null
  
)

export default component.exports